import { render, staticRenderFns } from "./VoyageView.vue?vue&type=template&id=19b53704&"
import script from "./VoyageView.vue?vue&type=script&lang=js&"
export * from "./VoyageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports